import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { text_s, heading_m, link, text_xscap, mq } from '_utils/styles';
import { Image as SCImage } from '@sitecore-jss/sitecore-jss-react';
import { spacing } from '_utils/props';

export const Card = styled.div`
  ${({ theme }) => spacing({ theme, $py: 3 })}
  display: flex;
  align-items: flex-start;
  @media print {
    page-break-inside: avoid;
  }
`;

export const DetailsContainer = styled.div`
  flex: 1 1 auto;
`;

export const Title = styled(NavLink)`
  ${link}
  ${heading_m}
  margin: 0;
`;

export const Description = styled.p`
  ${text_s}

  ${Title} + & {
    ${({ theme }) => spacing({ theme, $mt: 2, $mb: 0 })}
  }
`;

export const Category = styled.p`
  ${text_xscap}
  ${({ theme }) => spacing({ theme, $mb: 1 })}
  display: block;
`;

export const ImageContainer = styled.div`
  flex: none;
  width: 56px;
  height: 56px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.background.senary};
  ${({ theme }) => spacing({ theme, $ml: 4 })}

  ${mq('sm')} {
    width: 128px;
    height: 128px;
  }

  border-radius: 4px;
  overflow: hidden;

  .type-publication & {
    border-radius: 0;
    background-color: transparent;
  }

  .type-focus & {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
`;

export const Image = styled(SCImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  font-family: 'object-fit: cover';

  .type-publication &,
  .type-focus & {
    object-fit: contain;
    font-family: 'object-fit: contain';
  }

  .type-focus & {
    width: calc(100% - 32px);
    height: calc(100% - 32px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const AttributesWrapper = styled.span`
  ${text_s}
  margin: 8px 0;
  display: block;
  color: ${({ theme }) => theme.card.secondary};

  path {
    fill: ${({ theme }) => theme.card.secondary};
  }
`;
